var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardBg = function SvgCreditCardBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "M24.739 10.729c2.144-4.373 8.378-4.373 10.522 0a5.86 5.86 0 0 0 6.525 3.142c4.756-1.05 8.643 3.824 6.561 8.227a5.86 5.86 0 0 0 1.612 7.06c3.786 3.065 2.399 9.142-2.342 10.26a5.86 5.86 0 0 0-4.515 5.662c-.035 4.87-5.651 7.575-9.481 4.566a5.86 5.86 0 0 0-7.242 0c-3.83 3.01-9.446.304-9.48-4.566a5.86 5.86 0 0 0-4.516-5.662c-4.74-1.118-6.128-7.195-2.342-10.26a5.86 5.86 0 0 0 1.612-7.06c-2.082-4.403 1.804-9.277 6.56-8.227a5.86 5.86 0 0 0 6.525-3.142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "M17.5 17.912h24v24h-24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M21.518 23.912h15.964c.551 0 .998.447.998.998v10.9a1 1 0 0 1-.998.999H21.518a1 1 0 0 1-.998-.998V24.91m.998-.998a1 1 0 0 0-.998.998m.998-.998a1 1 0 0 0-.998.998m.998-.998h3.302m-4.3.998v3.323m17.98 4.255v3.323a1 1 0 0 1-.998.998H34.18m4.32-8.577V24.91a1 1 0 0 0-.998-.998H34.16h.02M24.82 36.81h-3.322a1 1 0 0 1-.998-.998v-3.323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD1EC",
    stroke: "#fff",
    d: "M21 32.412h17v1H21z"
  })));
};
export default SvgCreditCardBg;